import {
	normalizarUnidades,
	unidadBase,
	opcionesUnidades,
	aCantidadBase,
	aCantidadUnidad,
	precioPorUnidad,
	usaPrecioPaquete,
	filaUnidadDeLinea,
	describirCantidad,
} from "../../../utils/unidades";
import { formatNumber } from "../../../utils/helpers";

/**
 * Lógica de unidad/factor/conversión compartida entre los dos useProducto.js
 * (Facturacion/hooks e Ingresos/Hooks). No es un hook con estado propio: cada
 * useProducto.js sigue siendo dueño de su productoInfo; esto sólo evita
 * duplicar la aritmética de conversión y el armado de la opción de unidad.
 */

/** La fila normalizada de unidades, lista para pasar a un <Select>. */
export const construirOpcionUnidad = (fila) =>
	fila && {
		value: fila.unidad,
		label: fila.unidad,
		id: fila.unidad_id,
		unidad_id: fila.unidad_id,
		factor: fila.factor,
	};

/** La unidad base de un producto, ya en forma de opción de <Select>. */
export const opcionUnidadBase = (producto) =>
	construirOpcionUnidad(unidadBase(producto));

/**
 * Las etiquetas de las listas de precio llevan el monto ("2 -> 1,200.00").
 * Al escalar por unidad hay que reescribirlo, o el select muestra el precio
 * de la unidad base mientras la línea cobra el de la CAJA.
 */
export const reetiquetarPrecio = (label, valor) => {
	if (typeof label !== "string" || !label.includes("->")) return label;
	return `${label.split("->")[0].trim()} -> ${formatNumber(valor)}`;
};

/**
 * Escala cada opción de precio (lista de precio del producto) según la
 * unidad seleccionada: el precio de paquete propio de la lista si la unidad es
 * el empaque y lo tiene, si no factor × precio de la lista. Conserva
 * `valorBase` (el valor sin escalar) para poder re-escalar sin arrastrar el
 * factor anterior cuando cambia la unidad.
 */
export const escalarPreciosPorUnidad = (precios, unidadSeleccionada) =>
	(precios || []).map((precio) => {
		const value = precioPorUnidad(precio.value, unidadSeleccionada, precio.precio_paquete);
		return {
			...precio,
			valorBase: precio.value,
			value,
			label: reetiquetarPrecio(precio.label, value),
		};
	});

/** Cuántas unidades completas (CAJA, etc.) alcanzan con la existencia en base. */
export const cantidadMaximaEnUnidad = (existenciaBase, factor) =>
	Math.floor(aCantidadUnidad(existenciaBase, factor));

export {
	normalizarUnidades,
	unidadBase,
	opcionesUnidades,
	aCantidadBase,
	aCantidadUnidad,
	precioPorUnidad,
	usaPrecioPaquete,
	filaUnidadDeLinea,
	describirCantidad,
};
